import style from "../index.module.scss";
const DotPage=()=>{
    return(
        <div className={style.loadingDots}>
            <div className={style.loading_item}></div>
            <div className={style.loading_item}></div>
            <div className={style.loading_item}></div>
        </div>
    )
}
export default DotPage